import 'react-app-polyfill/ie11'
import React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import configureStore from './store/configureStore'
import App from './App'
import UnsupportedBrowser from './components/misc/UnsupportedBrowser'
import { unregister } from './registerServiceWorker'

// Create browser history to use in the Redux store
const baseUrl = document
  .getElementsByTagName('base')[0]
  .getAttribute('href') as string
const history = createBrowserHistory({ basename: baseUrl })

localStorage.setItem('currentPuzzle', '0')

// const persistedState = loadState();

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history) //, persistedState);

// store.subscribe(throttle(() => {
//   saveState({
//     game: store.getState().game
//   });
// }, 1000));

if (typeof crypto === 'undefined') {
  ReactDOM.render(<UnsupportedBrowser />, document.getElementById('root'))
} else {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  )
}

unregister()
